var map = {
	"./10.jpg": 4650,
	"./11.jpg": 7848,
	"./12.jpg": 2623,
	"./15.jpg": 2944,
	"./17.jpg": 1618,
	"./2.jpg": 8486,
	"./21.jpg": 661,
	"./25.jpg": 8371,
	"./9.jpg": 9496,
	"./danie_party.jpeg": 7709,
	"./daniel2.jpg": 4538,
	"./daniel3.jpg": 2956,
	"./daniel4.jpg": 6447,
	"./daniel5.jpg": 5020,
	"./danielvinyl.jpg": 2267,
	"./dd.png": 5837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4852;